import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CKYC_CHECK,
  CREATE_APPLICATION,
  DELETE_UPLOADED_DOCUMENT,
  DOWNLOAD_OSV_FILE,
  DOWNLOAD_Uploaded_File,
  ESIGN_ENDPOINT,
  GET_APPLICATION_DATA,
  GET_SOA_FILE_BY_PAN,
  SUBMIT_APPLICATION,
  UPLOAD_DOCUMENT_ENDPOINT,
  SOFTDELETE_INVESTMENT,
  UPLOAD_DOCUMENT_ENDPOINTLINUX,
  UPLOAD_DOCUMENT_ENDPOINTSERVER,
  PHYSICAL_SIGN,
  UPDATE_AML_COMMENTS,
  DOWNLOAD_OFFLINECA,
  GET_CA_MASTERDETAILS,
  APPROVE_CLASS,
  APPROVE_AGE,
  GET_APPLICATION_DOCUMENT,
  APPROVE_COMMITMENT,
  GET_OFFLINE_APPLICATIONNO,
  UPLOAD_DOCUMENT_VIA_EC2,
  SUBMIT_WETSIGN_APPLICATION,
  SUBMIT_OFFLINE_APPLICATION,
  GET_DUE_DILIGENCE,

  UPDATE_DUE_DILIGENCE,
  GET_APPLICATION_PRE_SUBMISSION_MESSAGE,
  APPROVE_DUE_DILIGENCE,
  GET_DUE_Accredited,
  DOWNLOAD_ANNEXURE_SAMPLE,
  COMPLIANCE_APPROVAL,
  DOWNLOAD_DUE_DILIGENCE_DOCS,
  DOWNLOAD_MULTIPLE_FILES,
} from '../../core/constants/api-endpoints';
import { environment } from '../../../environments/environment';
import {
  ACCESS_TOKEN,
  AUTHORIZATION,
  BEARER_TOKEN_PREFIX,
} from '../../core/constants/app-strings';
import { UploadDocument, updateInvestmentAML, classApprovalbody, ageApprovalbody } from '../../core/model/application.model';
import { UploadData } from 'src/app/core/model/upload-document.model';

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  constructor(private http: HttpClient) { }

  checkCKYCAndSaveApplication(body) {
    const url = environment.APIURL + CREATE_APPLICATION;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, body, { headers });
  }

  validateOTP(body) {
    const url = environment.LINUX + '/api/CKYC/confirmOTPV13'
    let headers = {} as any;
    return this.http.post(url, body);
  }

  CKYCSearchAPI(body) {
    const url = environment.LINUX + '/api/CKYC/CKYCSearchAPI'
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http.post(url, body, { headers });
  }

  KRACheck(body: any) {
    const url = 'https://localhost:44343/api/KRA/KRAPANCheck'
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http.post(url, body, { headers });
  }

  KRASearchAPI(body) {
    const url = 'https://apis.eaaa.in' + '/api/KRA/KRAPANCheck'
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http.post(url, body, { headers });
  }

  KRADownloadAPI(body) {
    const url = 'https://apis.eaaa.in' + '/api/KRA/KRAPANDownload'
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http.post(url, body, { headers });
  }

  getInvestorDetailsforCKYC(pan: string) {
    const url = environment.APIURL + `/api/v1/external/getInvestorDetailsforCKYC/${pan}`;
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http.get(url, { headers })
  }

  getCKYC(body) {
    const url = environment.LINUX + '/api/CKYC/CkycDownloadAPI_V13';
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http.post(url, body, { headers });
  }

  getCKYCForNonIndi(body) {

    const url = environment.LINUX + '/api/CKYC/CkycDownloadAPI';
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http.post(url, body, { headers });
  }

  getApplicationByUuid(uuid: string) {
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const url = environment.APIURL + GET_APPLICATION_DATA + uuid;

    return this.http.get(url, { headers });
  }

  getPresubmissionMessageByUuid(uuid: string) {
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const url = environment.APIURL + GET_APPLICATION_PRE_SUBMISSION_MESSAGE + uuid;

    return this.http.get(url, { headers });
  }

  getAMLApplicationByUuid(uuid: string) {
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const url = environment.APIURL + GET_APPLICATION_DATA + 'AML/' + uuid;
    return this.http.get(url, { headers });
  }

  sendForEsignRequest(applicationId: string) {
    const url = environment.APIURL + ESIGN_ENDPOINT + `/${applicationId}`;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.get(url, { headers });
  }

  updateHolderAMLComments(body: updateInvestmentAML) {
    const url = environment.APIURL + UPDATE_AML_COMMENTS;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, body, { headers });
  }

  // rahin

  softdeleteApplication(applicationId: string) {
    const url =
      environment.APIURL + SOFTDELETE_INVESTMENT + `/${applicationId}`;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const body = {} as any;
    return this.http.post(url, body, { headers });
  }

  uploadDocument(file, body: UploadDocument) {
    const url = environment.APIURL + UPLOAD_DOCUMENT_ENDPOINT;
    const uploadData = new FormData();
    uploadData.append('documentType', body.documentType);

    if (body.holderUuid) {
      uploadData.append('holderUuid', body.holderUuid);
      uploadData.append('correspondanceSameAsPermanentAddress', body.correspondanceSameAsPermanentAddress);
      uploadData.append('nomineeUuid', '');
      uploadData.append('signatoryUuid', '');
    }
    if (body.nomineeUuid) {
      uploadData.append('nomineeUuid', body.nomineeUuid);
      uploadData.append('holderUuid', '');
      uploadData.append('signatoryUuid', '');
    }
    if (body.beneficiaryUuid) {
      uploadData.append('beneficiaryUuid', body.beneficiaryUuid);
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('signatoryUuid', '');
      uploadData.append('poaUuid', '');
    }
    if (body.signatoryUuid) {
      uploadData.append('signatoryUuid', body.signatoryUuid);
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
      uploadData.append('poaUuid', '');
    }
    if (body.poaUuid) {
      uploadData.append('poaUuid', body.poaUuid);
      uploadData.append('signatoryUuid', '');
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
    }

    if (body.uboUuid) {
      uploadData.append('uboUuid', body.uboUuid);
      uploadData.append('poaUuid', '');
      uploadData.append('signatoryUuid', '');
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
    }
    if (body.contactPersonUuid) {
      uploadData.append('contactPersonUuid', body.contactPersonUuid);
      uploadData.append('poaUuid', '');
      uploadData.append('signatoryUuid', '');
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
    }
    if (body.controllingPersonUuid) {
      uploadData.append('controllingPersonUuid', body.controllingPersonUuid);
      uploadData.append('poaUuid', '');
      uploadData.append('signatoryUuid', '');
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
    }
    if (body.groupid) {
      uploadData.append('groupid', body.groupid);
      uploadData.append('relation', body.relation);
    }
    if (body.transferId) {
      uploadData.append('transferApplication', body.transferApplication);
      uploadData.append('transferId', body.transferId);
    }
    if (body.isCommitmentApproval == "1") {
      uploadData.append('isCommitmentApproval', body.isCommitmentApproval);
    }

    uploadData.append('applicationUuid', body.applicationUuid);
    uploadData.append('file', file, file?.name);

    let headers = {} as any;
    // headers[AUTHORIZATION] =
    //   BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, uploadData);
  }


  getSOAFileWithPan(body) {
    const url = environment.APIURL + GET_SOA_FILE_BY_PAN;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, body, { headers });
  }

  downloadDocument(docName, investorId, applicationUuid, fileName, transferApplication, isCommitmentApproval, docType = '', pledgeId = '') {
    const url = environment.APIURL + DOWNLOAD_Uploaded_File;

    let body = {} as any;
    body.investorId = investorId?.toString();
    body.applicationUuid = applicationUuid?.toString();
    body.documentName = docName;
    body.fileName = fileName;
    body.transferApplication = transferApplication;
    body.isCommitmentApproval = isCommitmentApproval;
    body.documentType = docType;
    body.pledgeId = pledgeId;

    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, body, { headers });
  }

  PPM(body) {
    const url = environment.LINUX + '/api/investor/ppmdownload'
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    return this.http.post(url, body, { headers });
  }

  ckeckCKYC(body: { pan: string; dateOfBirth: string }) {
    const url = environment.APIURL + CKYC_CHECK;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, body, { headers });
  }

  //submitApplication(uuid: string, physicalSign = false, certificateNumber: any) {
  submitApplication(req: any) {
    const url =
      //environment.APIURL + SUBMIT_APPLICATION + `/${uuid}/${certificateNumber}/${physicalSign}`;
      environment.APIURL + SUBMIT_APPLICATION;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const body = {} as any;
    return this.http.post(url, req, { headers });
  }

  deleteDocument(documentid: number, fileName: string) {
    const url =
      environment.APIURL + DELETE_UPLOADED_DOCUMENT + `/${documentid}`;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.get(url, { headers });
  }

  getApllicationById(applicationuuId) {
    const url = environment.APIURL + GET_APPLICATION_DATA + applicationuuId;
    let headers = {} as any;
    const body = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, body, { headers });
  }


  uploadDocumentServer(file, body: UploadDocument) {
    const url = environment.APIURL + UPLOAD_DOCUMENT_ENDPOINTSERVER;
    // const url = environment.LINUX + UPLOAD_DOCUMENT_ENDPOINTLINUX;

    const uploadData = new FormData();
    uploadData.append('documentType', body.documentType);
    if (body.holderUuid) {
      uploadData.append('holderUuid', body.holderUuid);
      uploadData.append('nomineeUuid', '');
      uploadData.append('signatoryUuid', '');
    }
    if (body.nomineeUuid) {
      uploadData.append('nomineeUuid', body.nomineeUuid);
      uploadData.append('holderUuid', '');
      uploadData.append('signatoryUuid', '');
    }
    if (body.beneficiaryUuid) {
      uploadData.append('beneficiaryUuid', body.beneficiaryUuid);
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('signatoryUuid', '');
      uploadData.append('poaUuid', '');
    }
    if (body.signatoryUuid) {
      uploadData.append('signatoryUuid', body.signatoryUuid);
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
      uploadData.append('poaUuid', '');
    }
    if (body.poaUuid) {
      uploadData.append('poaUuid', body.poaUuid);
      uploadData.append('signatoryUuid', '');
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
    }

    if (body.uboUuid) {
      uploadData.append('uboUuid', body.uboUuid);
      uploadData.append('poaUuid', '');
      uploadData.append('signatoryUuid', '');
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
    }
    if (body.contactPersonUuid) {
      uploadData.append('contactPersonUuid', body.contactPersonUuid);
      uploadData.append('poaUuid', '');
      uploadData.append('signatoryUuid', '');
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
    }
    if (body.controllingPersonUuid) {
      uploadData.append('controllingPersonUuid', body.controllingPersonUuid);
      uploadData.append('poaUuid', '');
      uploadData.append('signatoryUuid', '');
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
    }
    if (body.groupid) {
      uploadData.append('groupid', body.groupid);
      uploadData.append('relation', body.relation);
    }

    uploadData.append('applicationUuid', body.applicationUuid);
    uploadData.append('filename', file?.name);
    //uploadData.append('file', file, file?.name);

    let headers = {} as any;
    // headers[AUTHORIZATION] =
    //   BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, uploadData);
  }

  uploadDocumentLinux(file, body: UploadDocument) {
    // const url = environment.APIURL + UPLOAD_DOCUMENT_ENDPOINT;
    const url = environment.LINUX + UPLOAD_DOCUMENT_ENDPOINTLINUX;

    const uploadData = new FormData();
    uploadData.append('documentType', body.documentType);
    if (body.holderUuid) {
      uploadData.append('holderUuid', body.holderUuid);
      uploadData.append('nomineeUuid', '');
      uploadData.append('signatoryUuid', '');
    }
    if (body.nomineeUuid) {
      uploadData.append('nomineeUuid', body.nomineeUuid);
      uploadData.append('holderUuid', '');
      uploadData.append('signatoryUuid', '');
    }
    if (body.beneficiaryUuid) {
      uploadData.append('beneficiaryUuid', body.beneficiaryUuid);
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('signatoryUuid', '');
      uploadData.append('poaUuid', '');
    }
    if (body.signatoryUuid) {
      uploadData.append('signatoryUuid', body.signatoryUuid);
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
      uploadData.append('poaUuid', '');
    }
    if (body.poaUuid) {
      uploadData.append('poaUuid', body.poaUuid);
      uploadData.append('signatoryUuid', '');
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
    }

    if (body.uboUuid) {
      uploadData.append('uboUuid', body.uboUuid);
      uploadData.append('poaUuid', '');
      uploadData.append('signatoryUuid', '');
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
    }
    if (body.contactPersonUuid) {
      uploadData.append('contactPersonUuid', body.contactPersonUuid);
      uploadData.append('poaUuid', '');
      uploadData.append('signatoryUuid', '');
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
    }
    if (body.controllingPersonUuid) {
      uploadData.append('controllingPersonUuid', body.controllingPersonUuid);
      uploadData.append('poaUuid', '');
      uploadData.append('signatoryUuid', '');
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
    }
    if (body.groupid) {
      uploadData.append('groupid', body.groupid);
      uploadData.append('relation', body.relation);
    }

    uploadData.append('applicationUuid', body.applicationUuid);
    uploadData.append('file', file, file?.name);

    let headers = {} as any;
    // headers[AUTHORIZATION] =
    //   BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, uploadData);
  }


  //to upload 2 physical sign documents
  async uploadFile(file: File, body: UploadDocument) {
    const url = environment.LINUX + '/api/files/UploadS3Bucket';
    const uploadData = new FormData();
    uploadData.append('documentType', body.documentType);
    if (body.holderUuid) {
      uploadData.append('holderUuid', body.holderUuid);
      uploadData.append('nomineeUuid', '');
      uploadData.append('signatoryUuid', '');
    }
    if (body.nomineeUuid) {
      uploadData.append('nomineeUuid', body.nomineeUuid);
      uploadData.append('holderUuid', '');
      uploadData.append('signatoryUuid', '');
    }
    if (body.beneficiaryUuid) {
      uploadData.append('beneficiaryUuid', body.beneficiaryUuid);
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('signatoryUuid', '');
      uploadData.append('poaUuid', '');
    }
    if (body.signatoryUuid) {
      uploadData.append('signatoryUuid', body.signatoryUuid);
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
      uploadData.append('poaUuid', '');
    }
    if (body.poaUuid) {
      uploadData.append('poaUuid', body.poaUuid);
      uploadData.append('signatoryUuid', '');
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
    }

    if (body.uboUuid) {
      uploadData.append('uboUuid', body.uboUuid);
      uploadData.append('poaUuid', '');
      uploadData.append('signatoryUuid', '');
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
    }
    if (body.contactPersonUuid) {
      uploadData.append('contactPersonUuid', body.contactPersonUuid);
      uploadData.append('poaUuid', '');
      uploadData.append('signatoryUuid', '');
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
    }
    if (body.controllingPersonUuid) {
      uploadData.append('controllingPersonUuid', body.controllingPersonUuid);
      uploadData.append('poaUuid', '');
      uploadData.append('signatoryUuid', '');
      uploadData.append('holderUuid', '');
      uploadData.append('nomineeUuid', '');
      uploadData.append('beneficiaryUuid', '');
    }
    if (body.groupid) {
      uploadData.append('groupid', body.groupid);
      uploadData.append('relation', body.relation);
    }

    uploadData.append('applicationUuid', body.applicationUuid);
    uploadData.append('file', file, file?.name);

    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return await this.http.post(url, uploadData, { headers }).toPromise();
  }

  // save physical upload details
  savePhysicalUploadDetails(
    InvestmentId,
    InvestorId,
    userId,
    Document1,
    Document2,
    SignedDate,


  ) {
    const url = environment.APIURL + PHYSICAL_SIGN;

    let body = {} as any;
    body.InvestmentId = InvestmentId;
    body.InvestorId = InvestorId;
    body.userId = userId;
    body.Document1 = Document1;
    body.Document2 = Document2;
    body.SignedDate = SignedDate;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);

    return this.http.post(url, body, { headers });
  }


  downloadOfflineCA(childfundid: any, typeOfInvestor: any, applicationType: string) {
    //const url = environment.APIURL + DOWNLOAD_OFFLINECA;
    const url = environment.APIURL + DOWNLOAD_OFFLINECA + `/${childfundid}/${typeOfInvestor}/${applicationType}`;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const body = {} as any;
    return this.http.post(url, body, { headers });
  }


  getCA_Master() {
    //const url = environment.APIURL + DOWNLOAD_OFFLINECA;
    const url = environment.APIURL + GET_CA_MASTERDETAILS;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const body = {} as any;
    // return this.http.get(url, body, { headers });
    return this.http.get(url, { headers });

  }

  setAgeApproval(body: ageApprovalbody) {
    const url =
      environment.APIURL + APPROVE_AGE;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, body, { headers });
  }

  setClassApproval(body: classApprovalbody) {
    const url =
      environment.APIURL + APPROVE_CLASS;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, body, { headers });
  }

  getApplicationDocuments(body: any) {

    const url = environment.APIURL + GET_APPLICATION_DOCUMENT;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, body, { headers });
  }

  setCommitmentApproval(body: classApprovalbody) {
    const url =
      environment.APIURL + APPROVE_COMMITMENT;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, body, { headers });
  }

  getOfflineApplication() {
    const url = environment.APIURL + GET_OFFLINE_APPLICATIONNO;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.get(url, { headers });
  }

  uploadDocumentViaEC2Instance(file: File, data: UploadData) {
    const url = environment.APIURL + UPLOAD_DOCUMENT_VIA_EC2;
    let headers = {} as any;
    headers[AUTHORIZATION] = BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);

    const uploadData = new FormData();
    uploadData.append('documentType', data.documentType);
    uploadData.append('holderUuid', data.holderUuid);
    uploadData.append('applicationUuid', data.applicationUuid);
    uploadData.append('applicationType', data.applicationType);
    uploadData.append('formid', data.formid.toString());
    uploadData.append('pdfPageno', data.pdfPageno.toString());
    uploadData.append('applicationStatus', data.applicationStatus);
    uploadData.append('childfundid', data.childfundid.toString());
    uploadData.append('groupid', data.groupid.toString());

    uploadData.append('file', file, file?.name);

    return this.http.post(url, uploadData);
  }

  submitWetSignApplication(body: any) {
    const url = environment.APIURL + SUBMIT_WETSIGN_APPLICATION;
    let headers = {} as any;
    headers[AUTHORIZATION] = BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, body, { headers });
  }

  submitOfflineApplication(body: any) {
    const url = environment.APIURL + SUBMIT_OFFLINE_APPLICATION;
    let headers = {} as any;
    headers[AUTHORIZATION] = BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, body, { headers });
  }

  downloadDueDiligence(applicantType: string) {
    const url = `${environment.APIURL}${GET_DUE_DILIGENCE}/${applicantType}`;
    let headers = {} as any;
    headers[AUTHORIZATION] = BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const response = this.http.get<string>(url, { headers });
    return response;
  }

  updateDueDiligence(body: any, InvestorId: string) {
    const url = `${environment.APIURL}${UPDATE_DUE_DILIGENCE}/${InvestorId}`;
    let headers = {} as any;
    headers[AUTHORIZATION] = BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const response = this.http.post(url, body, { headers });
    return response;
  }

  approveDueDiligence(body: any, InvestorId: string) {
    const url = `${environment.APIURL}${APPROVE_DUE_DILIGENCE}/${InvestorId}`;
    let headers = {} as any;
    headers[AUTHORIZATION] = BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const response = this.http.post(url, body, { headers });
    return response;
  }

  downloadAllDocuments(body: any) {
    const url = `${environment.APIURL}${DOWNLOAD_MULTIPLE_FILES}`;

    let headers: any = {};
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);

    return this.http.post(url, body, { headers });
  }

  downloadAllApplications(body: any) {
    const url = `${environment.APIURL}${DOWNLOAD_MULTIPLE_FILES}`;

    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);

    return this.http.post(url, body, { headers });
  }

  getPDFFile(data: any) {
    let headers = {} as any;
    headers[AUTHORIZATION] = BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const url = `${environment.APIURL}/api/v1/cams/GetKycDoc`;
    return this.http.post(url, data, { headers });
  }

  getSignatory(body: any) {
    let headers = {} as any;
    headers[AUTHORIZATION] = BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(`${environment.APIURL}/api/v1/cams/getSignatoryDetails`, body, { headers });
  }

  downloadAccredited(applicantType: string) {
    const url = `${environment.APIURL}${GET_DUE_Accredited}/${applicantType}`;
    let headers = {} as any;
    headers[AUTHORIZATION] = BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const response = this.http.get<string>(url, { headers });
    return response;
  }

  downloadAnnexureSample(documentId: number) {
    const url = `${environment.APIURL}${DOWNLOAD_ANNEXURE_SAMPLE}`;

    const headers: any = {};
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);

    return this.http.get(url, {
      headers,
      params: {
        documentId: documentId.toString()
      }
    });
  }

  complianceApproval(payload: any) {
    const url =
      `${environment.APIURL}${COMPLIANCE_APPROVAL}`;
    const headers: any = {};
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const response = this.http.post<string>(url, payload, { headers });
    return response;
  }
}
